/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CittadinoAssistenzaForm { 
    slug_comune?: string;
    studente_id?: string;
    messaggio: string;
    email?: string;
    cellulare?: string;
}

